import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title='RK Mart' link='https://rk-mart.herokuapp.com' bg='linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%)' mdxType="ProjectCard">
  A Complete Ecommerce Mobile Responsive Web Application built in Most popular
  framework of JavaScript, React JS. Using Firebase Authentication and
  Firestore, Stripe Payments, Redux(plus Sagas), Hooks, Styled-Components and
  some techniques for Performance and Optimization.
    </ProjectCard>
    <ProjectCard title='Alan AI News Reader' link='https://alan-ai-by-rk.netlify.app/' bg='linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%)' mdxType="ProjectCard">
  Conversational Voice Controlled React News Application using Alan AI. Alan AI
  is a revolutionary speech recognition software that allows you to add voice
  capabilities to your applications.
    </ProjectCard>
    <ProjectCard title='Movies Info Tracker' link='https://moviesinfotracker.netlify.app/' bg='linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%)' mdxType="ProjectCard">
  React Movies Info Tracker APP using OMDB API.Leveraging Axios, Sweetalert and
  Material UI Components.
    </ProjectCard>
    <ProjectCard title='Weather App' link='https://weather-app4629.netlify.app/' bg='linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%)' mdxType="ProjectCard">
  A simple React PWA App to Search Weather Conditions by Searching the names of
  city, country etc.Leveraging Axios to play with the API.
    </ProjectCard>
    <ProjectCard title='Advice Generator' link='https://advicegeneratorbyrk.netlify.app' bg='linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%)' mdxType="ProjectCard">
  A React Advice Generator PWA.Used Axios to play with the Advice Slip JSON API.
    </ProjectCard>
    <ProjectCard title='TODO App' link='https://todo-react-app-pwa.vercel.app' bg='linear-gradient(to right, #ad5389, #3c1053);' mdxType="ProjectCard">
  A simple React PWA Todo List App.Leveraging React-Flip-Move, Styled-Components
  and SweetAlerts libraries.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      